import { Vector2, Line3, Vector3 } from 'three';

export class Line3X
{
  public static distanceToPoint( self:Line3, p:Vector3, clamp:boolean = false ):number
  {
    let point3 = p;
    let line3  = self;
    let closestPoint = line3.closestPointToPoint( point3, clamp, new Vector3() );

    let distanceToPoint = point3.sub( closestPoint ).length();
    
    return distanceToPoint;
  
  }

  public static distanceToLine( self:Line3, s:Line3 ):number
  {
    var points = Line3X.closestPointsToLine( self, s );
    return points[ 1 ].sub(  points[ 0 ] ).length();
  }

  public static closestPointsToLine( self:Line3, s:Line3 ):Vector3[] 
  {
    var parameters = Line3X.closestParametersToLine( self, s );

    let result = 
    [ 
      self.at( parameters.x, new Vector3() ), 
      s.at( parameters.y, new Vector3() ) 
    ];

    return result;
  }

  public static closestParametersToLine( self:Line3, s:Line3 ):Vector2
  {     
    let epsilon = 0.0000000000001;

    var u = self.delta( new Vector3() );
    var v = s.delta( new Vector3() );
    var w = self.start.clone().sub( s.start );

    var a = u.clone().dot( u );
    var b = u.clone().dot( v );
    var c = v.clone().dot( v );
    var d = u.clone().dot( w );
    var e = v.clone().dot( w );

    var DD = a * c - b * b;

    var sc = 0;
    var sN = 0;
    var sD = 0;

    var tc = 0;
    var tN = 0;
    var tD = 0;

    sD = DD;
    tD = DD;

    if ( DD < epsilon ) 
    {
      sN = 0.0;
      sD = 1.0;
      tN = e;
      tD = c;
    }
    else
    {
      sN = b * e - c * d ;
      tN = a * e - b * d ;

      if ( sN < 0.0 )
      {
        sN = 0.0;
        tN = e;
        tD = c;
      }
      else if ( sN > sD ) 
      {
        sN = sD;
        tN = e + b;
        tD = c;
      }
    }

    if ( tN < 0 || tN > tD )
    {
      var tN_bigger_tD = tN >= 0 && tN > tD;

      tN = tN_bigger_tD ? tD : 0;

      var inbetween = tN_bigger_tD ? ( -d + b ) : ( -d );
      var isSmaller = inbetween < 0;
      var isBigger  = inbetween > a;

      sN = isSmaller ? 0 : isBigger ? sD : inbetween; 
      sD = ! isSmaller && ! isBigger ?  a : sD;
    }

    sc = Math.abs( sN ) < epsilon ? 0 : sN / sD;
    tc = Math.abs( tN ) < epsilon ? 0 : tN / tD;

    return new Vector2( sc, tc ); 

  }
}